<template>
  <image-description-list
    title="insurer.callCentreServices"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconPurple', imgFormat: 'svg' }"
    :starBackgroundLeftObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleLeftBig', imgFormat: 'svg', bottom: '-60%' }"
    :isShowStarBackgroundRight="false"
    :imageDescList="insurerStore.photoDescList"
    labelColor="#8F8348"
    descColor="#373F41"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useInsurerStore } from "@/stores/insurer";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const insurerStore = useInsurerStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>